<div class="Stars"
[attr.style]="sanitizer.bypassSecurityTrustStyle('--rating: ' + rating )"
aria-label="Rating out of 5." ></div>
